import { useState } from 'react'
import { useConfig } from '../auth'
import { authenticateByToken } from '../lib/allauth'
import { Alert, Button } from 'antd'

function installGoogleOneTap (cb) {
  const id = 'google-one-tap'
  const scr = document.getElementById(id)
  if (!scr) {
    const scr = document.createElement('script')
    scr.id = id
    scr.src = '//accounts.google.com/gsi/client'
    scr.async = true
    scr.addEventListener('load', function () {
      cb()
    })
    document.body.appendChild(scr)
  } else {
    cb()
  }
}

export default function GoogleOneTap (props) {
  // Google One Tap login is disabled
  return null
}
